import {
	IconButton,
	Popper,
	Grow,
	Paper,
	ClickAwayListener,
	MenuList,
	MenuItem,
	Stack,
	Typography,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import React, { useState, useRef, useEffect } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import LanguageIcon from '@mui/icons-material/Language';
import AppsIcon from '@mui/icons-material/Apps';
import EditIcon from '@mui/icons-material/Edit';

const AttachmentsOptions = ({ row, handlePreview, handleRename }) => {
	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};
	const handleDownload = () => {
		if (!row.isFolder) {
			const downloadUrl = row['@microsoft.graph.downloadUrl'];
			if (downloadUrl) {
				const link = document.createElement('a');
				link.href = downloadUrl;
				link.download = row.name;
				document.body.appendChild(link);
				link.click();
				link.remove();
			}
		}
	};

	return (
		<>
			<IconButton aria-label='more' ref={anchorRef} onClick={handleToggle}>
				<MoreHorizIcon />
			</IconButton>

			<Popper open={open} anchorEl={anchorRef.current} placement='right' transition>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem={open}>
									<MenuItem
										onClick={() => {
											handlePreview(row);
											setOpen(false);
										}}
									>
										<Stack direction='row' alignItems={'center'} spacing={1}>
											<LanguageIcon sx={(theme) => ({ color: theme.palette.primary.main })} />
											<Typography noWrap>Open in Browser</Typography>
										</Stack>
									</MenuItem>
									<MenuItem
										onClick={() => {
											handleDownload();
											setOpen(false);
										}}
									>
										<Stack direction='row' alignItems={'center'} spacing={1}>
											<DownloadIcon sx={(theme) => ({ color: theme.palette.primary.main })} />
											<Typography noWrap>Download</Typography>
										</Stack>
									</MenuItem>
									<MenuItem
										onClick={() => {
											handleRename(row);
											setOpen(false);
										}}
									>
										<Stack direction='row' alignItems={'center'} spacing={1}>
											<EditIcon sx={(theme) => ({ color: theme.palette.primary.main })} />
											<Typography noWrap>Update</Typography>
										</Stack>
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};

export default AttachmentsOptions;
